module.exports = __webpack_public_path__ + "static/grandprize-prize-xbox-276f742fa442fb0b15e4a016362aad0a.png";